const htmlTitlePattern = /<title>(.*?)<\/title>/i;
const htmlTagPattern = /<[^>]+>/g;

const maybeParseJson = (value) => {
  if (typeof value !== 'string') return value;
  const trimmed = value.trim();
  if (!trimmed) return '';
  if (!trimmed.startsWith('{') && !trimmed.startsWith('[')) return value;
  try {
    return JSON.parse(trimmed);
  } catch (_error) {
    return value;
  }
};

const detailFromObject = (value) => {
  if (!value || typeof value !== 'object') return '';
  const detail = maybeParseJson(value.detail);
  if (typeof detail === 'string' && detail.trim()) return detail.trim();
  if (detail && typeof detail === 'object') {
    return (
      detail.message ||
      detail.error ||
      detail.reason ||
      detail.blocker ||
      JSON.stringify(detail)
    );
  }
  return (
    value.message ||
    value.error ||
    value.reason ||
    value.blocker ||
    ''
  );
};

const detailFromHtml = (value) => {
  if (typeof value !== 'string' || !value.includes('<html')) return '';
  const title = value.match(htmlTitlePattern)?.[1]?.trim();
  if (title) return `Server returned an HTML error page: ${title}`;
  const plain = value.replace(htmlTagPattern, ' ').replace(/\s+/g, ' ').trim();
  return plain ? `Server returned an HTML error page: ${plain.slice(0, 160)}` : '';
};

export const formatApiErrorDetail = (
  error,
  fallback = 'Request failed. Check console for details.',
) => {
  const responseData = maybeParseJson(error?.response?.data);
  const objectDetail = detailFromObject(responseData);
  if (objectDetail) return objectDetail;

  const htmlDetail = detailFromHtml(responseData);
  if (htmlDetail) return htmlDetail;

  if (typeof responseData === 'string' && responseData.trim()) {
    return responseData.trim();
  }
  if (error?.message && !/^Request failed with status code \d+$/.test(error.message)) {
    return error.message;
  }
  const status = error?.response?.status;
  return status ? `${fallback} (HTTP ${status})` : fallback;
};
